/*
 * @Description: 自动生成代码无需修改，可跑npm run services来重新生成
 */
import http from '@lib/http';
import { GetServerSidePropsContext } from 'next';

export interface Query {
  /**
   * 活动id
   */
  event_id: unknown;
}
/**
 * 拥有的日程列表
 */
export type OwnSchedules = {
  /**
   * 场地类型
   */
  venue_type: number;
  /**
   * 日程开始时间
   */
  begin_time?: number;
  /**
   * 日程名称
   */
  schedule_name?: string;
  /**
   * 日程id
   */
  schedule_id?: number;
  /**
   * 会议id
   */
  meeting_id?: number;
  /**
   * 日程状态：0:审核中；1:待开始；2:进入活动；3:查看回放；4:已结束
   */
  schedule_status?: number;
  /**
   * 回放url
   */
  meeting_url?: string;
  /**
   * 用户类型：guest：嘉宾；host：主持人；normal：观众
   */
  user_type?: string;
  /**
   * 会议号
   */
  meeting_code?: string;
  /**
   * 活动结束时间
   */
  end_time?: number;
  time_zone?: string;
}[];
/**
 * 审批中的日程列表
 */
export type ApprovingSchedules = {
  /**
   * 日程开始时间
   */
  begin_time?: number;
  /**
   * 日程名称
   */
  schedule_name?: string;
  /**
   * 日程id
   */
  schedule_id?: number;
  /**
   * 会议id
   */
  meeting_id?: number;
  /**
   * 日程状态：0:审核中；1:待开始；2:进入活动；3:查看回放；4:已结束
   */
  schedule_status?: number;
  /**
   * 回放url
   */
  meeting_url?: string;
  /**
   * 用户类型：guest：嘉宾；host：主持人；normal：观众
   */
  user_type?: string;
  /**
   * 会议号
   */
  meeting_code?: string;
  /**
   * 活动结束时间
   */
  end_time?: number;
  time_zone?: string;
}[];
export interface ActivitiesRegisterQueryUserScheduleRes {
  code?: number;
  data: Data;
  nonce?: string;
  msg?: string;
}
export interface Data {
  own_schedules?: OwnSchedules;
  approving_schedules?: ApprovingSchedules;
}

const ActivitiesRegisterQueryUserSchedule = async (data: Query, ctx?: GetServerSidePropsContext) => {
  const res = await http.get<ActivitiesRegisterQueryUserScheduleRes>(
    '/wemeet-tapi',
    '/v2/activities/register/query-user-schedule',
    data,
    ctx,
  );

  return res;
};

export default ActivitiesRegisterQueryUserSchedule;
